// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import 'es6-shim' // for IE 11
// TODO: instead of adding a shim, configure webpack to target ES5

// TODO: get the service worker working correctly
// import { install } from 'offline-plugin/runtime'
//
// // install service worker
// install()
if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
      .then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js